import { canCreateOrUpdate } from './validators/functions/can-create-or-update.function';

export * from './dtos/create-agent-category.dto';
export * from './dtos/update-agent-category.dto';
export * from './dtos/agent-categories-stats.dto';
export * from './dtos/agent-category-list.dto';
export * from './dtos/agent-category-record.dto';
export * from './dtos/agent-category-activity-event.dto';
export * from './dtos/agent-category-activity-event-hydration.dto';
export * from './dtos/agent-category-search.dto';

export * from './types/agent-categories-filters';

export * from './validators/schemas/create-agent-category.schema';
export * from './validators/schemas/update-agent-category.schema';

export const agentCategoryValidators = {
  canCreateOrUpdate,
};
